import request from '@/http/request'

export const getObClaimReportQuery = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/obClaimReport/page`, params)
}

export const exportObClaimReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/obClaimReport/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getObClaimEpcList = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/obClaimReport/epcDetail`, params)
}

export const exportObClaimEpc = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/obClaimReport/epcDetail/export`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}

export const getOutboundScanDropList = params => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/obClaimReport/tier1DcPlant`, params)
}
